import { makeAgendaWelcomeRepository } from 'modules/customer/infra/repositories';

import { FetchAgendaWelcomeDataUseCase } from './implementations/FetchAgendaWelcomeDataUseCase';

let instance: FetchAgendaWelcomeDataUseCase | null = null;

export default function makeFetchAgendaWelcomeDataUseCase() {
  if (!instance) {
    const repository = makeAgendaWelcomeRepository();

    instance = new FetchAgendaWelcomeDataUseCase(repository);
  }

  return instance;
}
